import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import CircularProgress from '@material-ui/core/CircularProgress';
import * as liveStationReducers from '../reducer';
import * as strings from '../../helpers/strings';
import * as stnFastDataReducer from '../../station-fastdata/reducer';

// Assets
import sunIco from '../../assets/icons/sun3d.png'
import humidityIco from '../../assets/icons/humidity.png'
import dropIco from '../../assets/icons/drop.png'
import tempIco from '../../assets/icons/temperature.png'
import windSpeedIco from '../../assets/icons/wind.png'
import windDIco from '../../assets/icons/windD3d.png'
import { Typography } from '@material-ui/core';

// importing Css
import '../../index.css';

class WeatherInfoTable extends Component {
    constructor() {
        super()
        this.state = {
            loading: true
        }
        this.handle_watherLink = this.handle_watherLink.bind(this)
    }

    componentDidUpdate(prevProps) {
        const { getDashbaordWeatherInfo, getLastFastData } = this.props;
    
        if (getDashbaordWeatherInfo !== prevProps.getDashbaordWeatherInfo || getLastFastData !== prevProps.getLastFastData) {
            if (getDashbaordWeatherInfo !== "" && getLastFastData !== null && getLastFastData.Data) {
                const hasData = Object.values(getLastFastData.Data).some(value => value !== 0);
                this.setState({ loading: !hasData });
                this.updateWeatherInfo();
            } else {
                this.setState({ loading: true });
            }
        }
    }

    updateWeatherInfo() {
        const { getDashbaordWeatherInfo, getLastFastData } = this.props;
        
        const windspeed_index = parseInt(getDashbaordWeatherInfo.WindSpeed, 10);
        const windSpeedElem = document.getElementById("windSpeed");
        if (windSpeedElem) {
            windSpeedElem.innerHTML = (getDashbaordWeatherInfo.WindSpeed !== "-1") ? getLastFastData.Data[windspeed_index] / 10 + "m/s" : 'Not Available';
            if ((getDashbaordWeatherInfo.WindSpeed !== "-1") && getLastFastData.Data[windspeed_index] < 0) {
                windSpeedElem.classList.add("danger")
            } else {
                windSpeedElem.classList.remove("danger")
            }
        }

        const humidity_index = parseInt(getDashbaordWeatherInfo.Humidity, 10);
        const humidityElem = document.getElementById("humidity");
        if (humidityElem) {
            humidityElem.innerHTML = (getDashbaordWeatherInfo.Humidity !== "-1") ? getLastFastData.Data[humidity_index] / 10 + "%" : 'Not Available';
            if ((getDashbaordWeatherInfo.Humidity !== "-1") && getLastFastData.Data[humidity_index] < 0) {
                humidityElem.classList.add("danger")
            } else {
                humidityElem.classList.remove("danger")
            }
        }

        const ambient_index = parseInt(getDashbaordWeatherInfo.AmbientTemperature, 10);
        const ambientElem = document.getElementById("ambient");
        if (ambientElem) {
            ambientElem.innerHTML = (getDashbaordWeatherInfo.AmbientTemperature !== "-1") ? getLastFastData.Data[ambient_index] / 10 + "°C" : 'Not Available';
            if ((getDashbaordWeatherInfo.AmbientTemperature !== "-1") && getLastFastData.Data[ambient_index] < 0) {
                ambientElem.classList.add("danger")
            } else {
                ambientElem.classList.remove("danger")
            }
        }

        const module_index = parseInt(getDashbaordWeatherInfo.ModuleTemperature, 10);
        const moduleElem = document.getElementById("module");
        if (moduleElem) {
            moduleElem.innerHTML = (getDashbaordWeatherInfo.ModuleTemperature !== "-1") ? getLastFastData.Data[module_index] / 10 + "°C" : 'Not Available';
            if ((getDashbaordWeatherInfo.ModuleTemperature !== "-1") && getLastFastData.Data[module_index] < 0) {
                moduleElem.classList.add("danger")
            } else {
                moduleElem.classList.remove("danger")
            }
        }

        const irradiance_index = parseInt(getDashbaordWeatherInfo.irradiance, 10);
        const irradianceElem = document.getElementById("irradiance");
        if (irradianceElem) {
            irradianceElem.innerHTML = (getDashbaordWeatherInfo.irradiance !== "-1") ? getLastFastData.Data[irradiance_index] / 10 + "W/m2" : 'Not Available';
            if ((getDashbaordWeatherInfo.irradiance !== "-1") && getLastFastData.Data[irradiance_index] < 0) {
                irradianceElem.classList.add("danger")
            } else {
                irradianceElem.classList.remove("danger")
            }
        }

        const WindDirection_index = parseInt(getDashbaordWeatherInfo.WindDirection, 10);
        const windDirectionElem = document.getElementById("WindDirection");
        if (windDirectionElem) {
            windDirectionElem.innerHTML = (getDashbaordWeatherInfo.WindDirection !== "-1") ? getLastFastData.Data[WindDirection_index] / 10 + "°" : 'Not Available';
            if ((getDashbaordWeatherInfo.WindDirection !== "-1") && getLastFastData.Data[WindDirection_index] < 0) {
                windDirectionElem.classList.add("danger")
            } else {
                windDirectionElem.classList.remove("danger")
            }
        }
    }

    handle_watherLink() {
        const { history } = this.props;
        history.push(`/station-fastdata`);
    }

    render() {
        const { loading } = this.state;

        return (
            <div className='weatherInfoDiv'>
                {loading ? (
                    <div className="loading">
                        <CircularProgress />
                        <Typography variant="h6">Loading...</Typography>
                    </div>
                ) : (
                    <>
                        <Typography
                            variant="h5"
                            color={strings.colorPrimary}
                            gutterBottom
                            onClick={this.handle_watherLink}
                            style={{ fontSize: '1rem', fontWeight: 500, cursor: 'pointer' }}
                        >
                            {strings.lblWeatherInfo}
                        </Typography>
                        <ul className='weatherInfoWrapper'>
                            <li className="weatherInfoInner">
                                <div className="weatherInfoDetails">
                                    <img src={sunIco} alt="Irradiance" className="sunEffect" loading="lazy" />
                                </div>
                                <p className="weatherInfoLabel"> {strings.lblIrradiance}: <span id="irradiance"> 0 </span> </p>
                            </li>
                            <li className="weatherInfoInner">
                                <div className="weatherInfoDetails">
                                    <img src={humidityIco} alt="Humidity" className="aniHumidity" loading="lazy" />
                                </div>
                                <p className="weatherInfoLabel"> {strings.lblHumidity}: <span id="humidity"> 0 </span> </p>
                            </li>
                            <li className="weatherInfoInner">
                                <div className="weatherInfoDetails">
                                    <img src={tempIco} alt="Ambient" className="amnbientmoduleTemp" loading="lazy" />
                                </div>
                                <p className="weatherInfoLabel"> {strings.lblAmbientTemperature}: <span id="ambient"> 0 </span> </p>
                            </li>
                            <li className="weatherInfoInner">
                                <div className="weatherInfoDetails">
                                    <img src={tempIco} alt="Module" className="amnbientmoduleTemp" loading="lazy" />
                                </div>
                                <p className="weatherInfoLabel"> {strings.lblModuleTemperature}: <span id="module"> 0 </span></p>
                            </li>
                            <li className="weatherInfoInner">
                                <div className="weatherInfoDetails">
                                    <img src={windSpeedIco} alt="Wind" className="aniWind" loading="lazy" />
                                </div>
                                <p className="weatherInfoLabel"> {strings.lblWindSpeed}:<span id="windSpeed"> 0 </span> </p>
                            </li>
                            <li className="weatherInfoInner">
                                <div className="weatherInfoDetails">
                                    <img src={windDIco} alt="Direction" className="aniWindDiret" loading="lazy" />
                                </div>
                                <p className="weatherInfoLabel"> {strings.lblWindDirection}: <span id="WindDirection"> 0 </span>  </p>
                            </li>
                        </ul>
                    </>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    getDashbaordWeatherInfo: stnFastDataReducer.getDashbaordWeatherInfo(state),
    getLastFastData: liveStationReducers.getLastFastData(state)
})

export default connect(mapStateToProps)(
    withRouter(
        (WeatherInfoTable)
    )
)
